import React, { useState } from 'react';
import ContactForm from './forms/ContactForm';
import SEO from './SEO';

const Unsubscribe = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSuccess = () => {
    setIsSubmitted(true);
  };

  if (isSubmitted) {
    return (
      <div className="unsubscribe-page">
        <SEO
          title="Unsubscribe Confirmation - Lloyd James Data Consultancy"
          description="Your unsubscribe request has been submitted successfully. You will be removed from our database within 48 hours."
          keywords="unsubscribe confirmation, data removal, Lloyd James Data Consultancy"
          canonical="/unsubscribe"
        />
        <div className="unsubscribe-container">
          <div className="unsubscribe-header">
            <h1>Thank You!</h1>
          </div>
          <div className="unsubscribe-subheader">
            <p>Your unsubscribe request has been submitted successfully. You will be removed from our database within 48 hours.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="unsubscribe-page">
      <SEO
        title="Unsubscribe - Lloyd James Data Consultancy"
        description="Remove your details from our database. Complete the unsubscribe form to be removed from Lloyd James Data Consultancy mailing lists within 48 hours."
        keywords="unsubscribe, remove data, mailing list removal, Lloyd James Data Consultancy, data privacy"
        canonical="/unsubscribe"
      />
      <div className="unsubscribe-container">
        {/* Header Section */}
        <div className="unsubscribe-header">
          <h1>Unsubscribe!</h1>
        </div>
        
        {/* Subheader Section */}
        <div className="unsubscribe-subheader">
          <p>If you would like to be removed from our database, please provide us your details in the form below.</p>
        </div>
        
        {/* Form Section */}
        <div className="unsubscribe-form-area" style={{ backgroundColor: 'rgb(58, 58, 58)' }}>
          <ContactForm
            title=""
            webFormId="lloyd_james_unsubscribe_form"
            includeAddress={true}
            includePostcode={true}
            includeMessage={false}
            captchaType="house"
            fieldLabels={{
              address: "1st Line of Address*",
              postcode: "Your Postcode*"
            }}
            submitButtonText="submit"
            onSuccess={handleSuccess}
            className="text-white"
            inputTextColor="text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;